import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  errorConfigNameSelector,
  errorConfigSelector,
} from '@src/store/errorLogicConfig/configContainer/selectors';
import { updateConfigConditions } from '@store/errorLogicConfig/configContainer/actions';
import FilterRowGroup from './FilterRowGroup';
import { StyledFooter, StyledErrorMsg } from '../styled';
import { normalizeBusinessErrorState } from './utils';

import { Input, Form, Checkbox } from 'antd';
import { renameShort } from '@src/utils/common';

function ConfigForm({ hasErrors }) {
  const dispatch = useDispatch();
  const name = useSelector(errorConfigNameSelector);
  const { state: configState } = useSelector(errorConfigSelector);

  const onChange = (e) => {
    dispatch(updateConfigConditions({ name: e.target.value }));
  };

  const onStatusChange = (e) => {
    dispatch(updateConfigConditions({ state: e.target.checked ? 2 : 1 }));
  };

  return (
    <Form layout="vertical">
      <Form.Item label="Config Name" required>
        <Input value={name} onChange={onChange} />
      </Form.Item>
      <FilterRowGroup />
      <Form.Item>
        <Checkbox
          checked={normalizeBusinessErrorState(configState) === 2}
          onChange={onStatusChange}
        >
          Enable
        </Checkbox>
      </Form.Item>
      <StyledFooter>
        Note: This configuration will label {renameShort('VSF')} and {renameShort('VPF')} failures
        that match the specified value as business logic errors.
      </StyledFooter>
      {hasErrors && <StyledErrorMsg>Please fill in the required fields.</StyledErrorMsg>}
    </Form>
  );
}

export default ConfigForm;
